import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import AlternativeOfferDetails from './AlternativeOfferDetails';

export type DriverResponseDialogPayload = {
  allInRate: number;
  originalAllInRate: number | null;
  alternativeAllInRate: number | null;
  alternativePickup: Date | string | null;
  alternativeDelivery: Date | string | null;

  originalPickupScheduled?: Date | string;
  originalPickupLatest?: Date | string | null;
  originalDeliveryScheduled?: Date | string;
  originalDeliveryLatest?: Date | string | null;
};

type Props = {
  visible: boolean;
  onClose: () => void;
  payload: DriverResponseDialogPayload | null;
};

export default function DriverResponseDialog({
  visible,
  onClose,
  payload,
}: Props) {
  if (!visible || !payload) {
    return null;
  }

  return (
    <Dialog title='Alternative Driver Response' onClose={onClose} className="dialog-w800">
      <AlternativeOfferDetails
        originalAllInRate={payload.originalAllInRate}
        alternativeAllInRate={payload.alternativeAllInRate}
        originalPickupScheduled={payload.originalPickupScheduled ?? ''}
        originalPickupLatest={payload.originalPickupLatest ?? null}
        alternativePickup={payload.alternativePickup}
        originalDeliveryScheduled={payload.originalDeliveryScheduled ?? ''}
        originalDeliveryLatest={payload.originalDeliveryLatest ?? null}
        alternativeDelivery={payload.alternativeDelivery}
      />
      <DialogActionsBar>
        <Button onClick={onClose}>Close</Button>
      </DialogActionsBar>
    </Dialog>
  );
}
